<nz-sider
  data-testid="sidebar"
  nzWidth="200"
  [nzCollapsed]="isCollapsed()"
  [nzCollapsedWidth]="40"
  nzTheme="light"
>
  <div class="sidebar-content" [class.sidebar-collapsed]="isCollapsed()">
    <div class="sidebar-logo">
      @if (isCollapsed()) {
        <img class="sidebar-logo-collapsed" alt="kerberos-logo" src="/logo/kerberos-short.svg" />
      } @else {
        <img alt="kerberos-logo" src="/logo/kerberos.svg" (click)="navigateToDefault()" />
      }
    </div>
    <div class="sidebar-menu">
      <aad-navigation-menu [isCollapsed]="isCollapsed()" />
      <div class="sidebar-actions">
        <aad-sidebar-actions [isCollapsed]="isCollapsed()" />
      </div>
    </div>
  </div>
</nz-sider>
